import React, {useState, useEffect} from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { Modal } from 'antd';
import { ExclamationCircleTwoTone } from '@ant-design/icons';
import "../App.css"

const NagScreen = (props) => {

    const [state, setState] = useState({
        isVisible: false,
    });

    const intl = useIntl();

    let license = useSelector(state => state.license);

    useEffect(() => {
        
        if (license && license.LicenseStatus === 'LICENSE_EXPIRED' && 1 === Math.floor(Math.random() * 2))
        {
            setState({ isVisible : true});
        }

    }, [license]); 
    
    const handleOk = () => {
        setState({ isVisible : false});

        window.open(intl.formatMessage({ id: "PurchaseLink" }), "_blank")
    };
    
    const handleCancel = () => {
        setState({ isVisible : false});
    };

    return (
        <Modal closable={false} title={intl.formatMessage({ id: "TrialExpired" })} open={state.isVisible} onOk={handleOk} onCancel={handleCancel}>          
            <p><ExclamationCircleTwoTone />   {intl.formatMessage({ id: "PurchaseLicense" })}</p>
            <p><b>{intl.formatMessage({ id: "TotalPagesMonitored" })} {license.RecordsCount}</b></p>
        </Modal>
    );
}

export default NagScreen;